import { render, staticRenderFns } from "./CollectionOperations.vue?vue&type=template&id=509062d2&"
import script from "./CollectionOperations.vue?vue&type=script&lang=js&"
export * from "./CollectionOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports